import React from 'react';
import { Dialog, T } from '@colonist/ui';
/** Confirmation dialog shown after a successful region change. dismiss confirms too. */ export const ChangeRegionSuccessDialog = ({ open, onConfirm })=>/*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onConfirm
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.changeRegion.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.changeRegion.success'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onConfirm
    })));
